import { IConfiguration } from "@/interfaces/local";

export const configuration: IConfiguration = {} as IConfiguration;
export const isDev: boolean = process.env.NODE_ENV !== "production";
export const isInTeamsWindowMode: boolean = window.self !== window.top;

export function isInWebMode(): boolean {
  return (
    isDev === true ||
    (isInTeamsWindowMode === false &&
      configuration.tenant != null &&
      configuration.tenant.length > 0 &&
      configuration.clientId != null &&
      configuration.clientId.length > 0 &&
      configuration.redirectUri != null &&
      configuration.redirectUri.length > 0)
  );
}

export function isInTeamsMode(): boolean {
  return !isInWebMode();
}
